export const SUBJECT_LIST = /* GraphQL */ `
  query ListSubjects($onlyMapSubjects: Boolean) {
    listSubjects(onlyMapSubjects: $onlyMapSubjects) {
      id
      name
      image
    }
  }
`;
